var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"confirm-fade"}},[(_vm.isShow)?_c('div',{staticClass:"my-confirm",on:{"click":function($event){return _vm.hidden()}}},[_c('div',{staticClass:"confirm-content-wrap"},[_c('p',{staticClass:"my-confirm-content"},[_vm._v(_vm._s(_vm.content))])])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }